import React, { useEffect } from 'react';

export const AdminRedirect = () => {
  useEffect(() => {
    // Redirect all'admin panel locale
    window.location.href = 'http://localhost:3001/';
  }, []);

  return <div>Redirecting to admin panel...</div>;
};
